module.exports = __webpack_public_path__ + "static/media/AXS.2dd9ce43.png";